﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import {
    TokenRequestMode,
    TokenRequestStatus,
} from "~base/Services/API/AuthToken";

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type CompletedLoginAttempt = {
    type: "completedLoginAttempt";
    requestMode: TokenRequestMode;
    status: TokenRequestStatus;
    redirectUri: string;
};
type Navigate = { type: "navigate"; uri: string; replace?: boolean };

export type LoginPageViewAction = CompletedLoginAttempt | Navigate;

export interface LoginPageState {
    tryResolveFromHiddenField: boolean;
    navigateUri: string;
    isNavigating?: boolean;
}

export function reducer<T>(
    state: LoginPageState,
    action: LoginPageViewAction
): LoginPageState {
    switch (action.type) {
        case "completedLoginAttempt": {
            return {
                ...state,
                tryResolveFromHiddenField: false,
                navigateUri: action.redirectUri,
            };
        }
        case "navigate": {
            return { ...state, navigateUri: action.uri, isNavigating: true };
        }
    }
}
